import { restPost } from "./RestClient";

export async function FetchCampaigns(data) {
    const res = await restPost(`Ads_Clients/FetchCampaigns`, data);
    return res.data;
}
export async function saveCampaign(data) {
    const res = await restPost(`Ads_Clients/saveCampaign`, data);
    return res.data;
}